export const TRANS_STATUS_TYPE_NO = '未入库';
export const TRANS_STATUS_TYPE_YES = '已入库';
export const TRANS_STATUS_TYPE_ABANDON = '放弃';
